import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { usePanelContext } from './usePanelContext';
const PanelScrollableContent = ({ children, className, ...rest }) => {
    const { bodyId } = usePanelContext();
    const dataAttributes = useDataAttributes(rest);
    return (_jsx("div", { className: buildClassName('color-black flex-auto overflow-auto', className), id: bodyId, ...dataAttributes, children: children }));
};
export default PanelScrollableContent;
//# sourceMappingURL=PanelScrollableContent.js.map